<template>
  <div  class="XkzBgfqkTjHome">
    <div class="contentCss" style="float: left;width:300px;">
      <el-tree
        style="margin-top:20px;"
        lazy
        check-strictly
        ref="xzqhTree"
        show-checkbox
        node-key="value"
        :default-expanded-keys="[activeNodeId]"
        :default-checked-keys="[activeNodeId]"
        :props="props"
        :load="loadNode"
        check-on-click-node
        @check-change="handleCheckChange"
      >
      </el-tree>
    </div>
    <div class="contentCss" style="display: inline-block;width: calc(100% - 340px);">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="formInline"
            label-position="left"
            label-width="80px"
          >
            <el-form-item label="申请日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="formInline.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                />
              </el-col>
              <el-col style="text-align: center" class="line" :span="3">-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="formInline.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="行政层级:">
              <el-select v-model="formInline.childFlag" filterable placeholder="请选择">
                <el-option
                  v-for="item in childFlagList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="核发日期:">
              <el-col :span="10">
                <el-date-picker
                    v-model="formInline.hfbeginTime"
                    type="date"
                    style="width: 100%"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                />
              </el-col>
              <el-col style="text-align: center" class="line" :span="3">-</el-col>
              <el-col :span="10">
                <el-date-picker
                    v-model="formInline.hfendTime"
                    type="date"
                    style="width: 100%"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                />
              </el-col>
            </el-form-item>
            <div>
              <el-button
                icon="el-icon-refresh-left"
                style="width: 90px; height: 39px"
                round
                size="small"
                @click="resetDataSource"
              >重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div style="margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;">
        <div class="tablemes">
          <span>购买证：</span>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcGmzGxdwyzExcel()"
          >导出购买证的购销单位一致的情况</el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcGmzXsdwNoYwlxExcel()"
          >导出购买证销售单位无生产/经营业务类型的情况</el-button>
        </div>
        <div class="tablemes" style="margin-top: 20px">
          <span>运输证：</span>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcDfysExcel()"
          >导出多方运输的运输证不规范情况</el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcYszXgdwBdyExcel()"
          >导出购买/退货运输证与购买证相关单位不对应情况</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {exportBgfGmzGxdwyz, exportBgfGmzXsdwNoYwlx, exportBgfYszdwbdy, exportBgfDfys} from "@/assets/js/sysgakh";
  import {getXzqTree, getXzqTreeS} from "@/assets/js/SplcPzym";

export default {
  name:'XkzBgfqkTj',
  data(){
    return {
      props: {
        label: "label",
        key: "value",
        isLeaf: (data, node) => {
          return !data.leaf;
        },
      },
      activeNodeId: 0, //当前选中区域Id
      activeLevel: "-1", //当前选中区域level
      formInline: { // 搜索表单
        beginTime: '',
        endTime: '',
        hfbeginTime: '',
        hfendTime: '',
        childFlag:'all',
      },
      childFlagList: [
        {
          label:"所有子级",
          value:"all"
        },
        {
          label:"仅直接子级",
          value:"one"
        },
      ],
    }
  },
  mounted() {
  },
  methods:{
    loadNode(node, resolve) {
      if (node.level == 0) {
        getXzqTree().then((res) => {
          resolve([res.data.data]);
        });
      }
      if (node.level > 0) {
        if (node.data.isReq) {
          getXzqTreeS(node.data.value).then((res) => {
            resolve(res.data.data);
          });
        } else {
          return resolve(node.data.children);
        }
        return resolve([]); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
      }
    },
    handleCheckChange(data, checked, node) {
      if (checked) {
        //实现单选功能
        this.activeNodeId = data.value;
        this.activeLevel = data.level;
        this.$refs.xzqhTree.setCheckedKeys([]);
        this.$refs.xzqhTree.setCheckedKeys([data.value]);
      }
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        beginTime: '',
        endTime: '',
        hfbeginTime: '',
        hfendTime: '',
        childFlag:'all',
      }
    },
    //导出购买证：购买单位和销售单位一致
    dcGmzGxdwyzExcel() {
      this.$message.info("正在导出中...")
      exportBgfGmzGxdwyz(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '购买单位和销售单位一致'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    //导出购买证：销售单位没有生产/经营业务类型
    dcGmzXsdwNoYwlxExcel() {
      this.$message.info("正在导出中...")
      exportBgfGmzXsdwNoYwlx(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '销售单位已入网但没有生产或经营业务类型'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    //导出运输证：购买/退货运输的运输证与购买证相关单位不对应
    dcYszXgdwBdyExcel() {
      this.$message.info("正在导出中...")
      exportBgfYszdwbdy(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '购买/退货运输证与购买证相关单位不对应'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    //导出运输证：多方运输不能形成一条链或一条链的首尾单位不对应
    dcDfysExcel() {
      this.$message.info("正在导出中...")
      exportBgfDfys(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '多方运输不规范'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
  }
}
</script>

<style scoped lang='less'>
  .XkzBgfqkTjHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .headerSearch {
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
        &:last-child {
          width: 90px;
          height: 39px;
          /deep/ .el-button {
            width: 90px !important;
            height: 39px;
            border-radius: 3px;
          }
        }
      }
    }
    .contentCss{
      height:825px;
      background-color: white;
      margin: 20px 20px 0px 0px;
      overflow-y: auto;
    }
    .sousuo {
      width: 95%;
      margin-left: auto;
      margin-right: auto;
      .sousuoButton {
        width: 90px;
        height: 39px;
        background: #4170ff;
        border-color: #4170ff;
      }
      .chongzhiButton {
        width: 90px;
        height: 39px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
